import { Component, inject, signal, computed } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { InstitutionService } from '@lb/api/mylb/services/institution.service';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs';
import { LoaderComponent } from '@lb/components/loader/loader.component';

@Component({
	standalone: true,
	selector: 'lrnr-enroll-learner',
	imports: [LoaderComponent],
	template: `
		@if (loading()) {
			<lb-loader></lb-loader>
		} @else if (hubspotCompanyID()) {
			<iframe [src]="hubspotFormUrl()" width="100%" allowfullscreen="true" style="border: 0; height: calc(100vh - 160px)"></iframe>
		} @else {
			<p>HubSpot Company ID not found. Please contact support.</p>
		}
	`
})
export class EnrollLearnerComponent {
	private _domSanitizer = inject(DomSanitizer);
	private institutionService = inject(InstitutionService);

	public loading = signal<boolean>(true);
	private institutionInfo = toSignal(this.institutionService.getInstitutions().pipe(tap((institutions) => this.loading.set(false))));
	public hubspotCompanyID = computed(() => {
		const institutions = this.institutionInfo();
		const hubspotIntegration = institutions?.[0]?.integrationSystemIds?.find((s) => s.applicationName === 'Hubspot');
		return hubspotIntegration?.applicationValue;
	});

	// Create a computed signal that returns a sanitized URL
	public hubspotFormUrl = computed<SafeResourceUrl>(() => {
		const baseUrl = 'https://2f7kf.share.hsforms.com/23lp6OLEIS8y_4GEt6Mf6yQ?2-42221703/cp_enrollment_intent_facilitator_id=';
		const fullUrl = baseUrl + this.hubspotCompanyID();
		return this._domSanitizer.bypassSecurityTrustResourceUrl(fullUrl);
	});

	constructor() {
		this.institutionService.getInstitutions().pipe(tap((institutions) => this.loading.set(false)));
	}
}
